import React from "react";
import "./EraPage.css"; // Make sure this CSS includes .renaissance-banner etc.

function Renaissance() {
  return (
    <div className="era-page">
      {/* Themed Banner */}
      <div className="era-banner renaissance-banner">
        <h1>🎨 The Renaissance: Age of Art & Ideas</h1>
        <p className="era-subtitle">Grade 5 - Revolutions & Discovery</p>
      </div>

      {/* Overview */}
      <section className="renaissance-overview">
        <h2>🌟 What Was the Renaissance?</h2>
        <p>
          The Renaissance means “rebirth”! It was a time when people became curious again about science, art, and the world around them—after the long Middle Ages. This era brought amazing paintings, big inventions, and the first books made by printing.
        </p>
      </section>

      {/* Key Figures & Events */}
      <section className="renaissance-key">
        <h2>🧠 Key People & Inventions</h2>
        <ul>
          <li>🎨 <strong>Leonardo da Vinci</strong>: Painted the Mona Lisa and dreamed of flying machines.</li>
          <li>📚 <strong>Gutenberg</strong>: Invented the printing press, which helped spread books and ideas fast.</li>
          <li>🌍 <strong>Explorers</strong>: Like Columbus and Magellan traveled across oceans.</li>
          <li>🔭 <strong>Galileo</strong>: Looked up at the stars and helped build modern science!</li>
        </ul>
      </section>

      {/* Story or Comic-style Section */}
      <section className="renaissance-story">
        <h2>📖 Mini Story: “Leo's Flying Machine”</h2>
        <p>
          Young Leo spent his days sketching gears and wings. While others played outside, he imagined gliders that soared through the sky. His biggest wish? To fly like the birds over Florence!
        </p>
      </section>

      {/* Educational Media */}
      <section className="renaissance-media">
        <h2>🎥 Watch and Discover</h2>
        <img
    className="renaissance-illustration"
    src="/images/renaissance-era-scene.png" // adjust path/filename as needed
    alt="Illustration of Leonardo da Vinci with flying machine sketches, Gutenberg with a printing press, and explorers with a map"
    style={{ width: "100%", maxWidth: 500, borderRadius: "1.5rem", margin: "0 auto", boxShadow: "0 4px 24px rgba(0,0,0,0.12)" }}
  />
      </section>

      {/* Quiz */}
      <section className="renaissance-quiz">
        <h2>🧠 What Do You Remember?</h2>
        <ol>
          <li>Who painted the Mona Lisa?</li>
          <li>What did Gutenberg invent?</li>
          <li>Why was the Renaissance important?</li>
        </ol>
        <p><em>(Try writing or drawing your answers!)</em></p>
      </section>

      {/* Timeline */}
      <section className="renaissance-timeline">
        <h2>📅 Timeline of the Renaissance</h2>
        <ul>
          <li>c. 1450 – Gutenberg invents the printing press</li>
          <li>1492 – Columbus discovers the Americas</li>
          <li>1503 – Leonardo paints the Mona Lisa</li>
          <li>1610 – Galileo improves the telescope</li>
        </ul>
      </section>
    </div>
  );
}

export default Renaissance;
